<template>
  <div class="fault-type-radio">
    <Modal :value="visible" title="选择位置" @on-cancel="onCancel">
      <Input search @on-search="onSearch" placeholder="名称搜索" />
      <div class="" style="height: 356px;overflow:auto;">
        <MyTree :data="treeData"
                :multiple="multiple"
                ref="tree"
                :filter-node-method="filterNode"
                :props="defaultProps" />
      </div>
      <div slot="footer" class="u-modal-wrapper">
        <Button type="primary" size="large" @click="onOk" class="u-modal-btn">确定</Button>
        <Button size="large" @click="onCancel" class="u-modal-btn">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getLocation } from "@/api/components.js";
import MyTree from "../my-tree";
export default {
  name: "location-radio",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    checkedId: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.getType();
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "title"
      },
      visible: this.value,
      // checkedData: this.checkedId,
      treeData: [] //属性结构数据
    };
  },
  methods: {
    getType() {
      getLocation({
        is_truename: 1
      })
        .then(res => {
          this.treeData = this.formatData(res.data);
          this.setChecked();
        })
        .catch(err => {
          console.log(err);
        });
    },
    formatData(data) {
      //整理接口返回的数据
      let res = [];
      // console.log(this.checkedData);
      data.forEach(item => {
        let obj = {
          title: item.place,
          id: item.id,
          // isCheck: true,
          rawData: item
          // checked: this.checkedData.indexOf(item.id) !== -1
        };
        if (item.lists && item.lists.length) {
          obj.children = this.formatData(item.lists);
        }
        res.push(obj);
      });
      return res;
    },
    loadData(item, callback) {
      setTimeout(() => {
        const data = [
          {
            title: "children1",
            loading: false,
            children: []
          },
          {
            title: "children",
            loading: false,
            children: []
          }
        ];
        callback(data);
      }, 1000);
    },
    onOk() {
      let checkedNodes = this.$refs.tree.getCheckedNodes();
      this.$emit("on-ok", checkedNodes);
      this.close();
    },
    onCancel() {
      this.close();
    },
    close() {
      this.visible = false;
      this.$emit("on-close");
      this.$emit("input", false);
    },
    onSearch(val) {
      this.$refs.tree.filter(val);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    setChecked() {
      const valArr = this.checkedId.map(item => {
        return { id: item };
      });
      this.$nextTick(() => {
        this.$refs.tree.setCheckedNodes(valArr);
      });
    }
  },
  watch: {
    value(val) {
      this.visible = val;
    },
    checkedId() {
      this.setChecked();
    }
  },
  components: {
    MyTree
  }
};
</script>

<style scoped></style>
